class SizeToggle {
  constructor () {
    this.setupListeners()
  }

  setupListeners () {
    this.handleUnit = this.handleUnit.bind(this)

    document.addEventListener('click', this.handleUnit)
  }

  async handleUnit (event) {
    if (!event.target.closest('[data-size-toggle-el="trigger"]')) return

    const currentUnit = document.body.dataset.sizeUnit
    const primaryUnit = document.body.dataset.primaryUnit
    const secondaryUnit = document.body.dataset.secondaryUnit

    const newUnit = currentUnit === primaryUnit ? secondaryUnit : primaryUnit

    document.body.setAttribute('data-size-unit', newUnit)

    await window.BAO.Cart.updateCartAttributes({
      size_guide_unit: newUnit,
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // eslint-disable-next-line no-new
  new SizeToggle()
})
